import script from "./CcMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./CcMessage.vue?vue&type=script&setup=true&lang=js"

import "./CcMessage.vue?vue&type=style&index=0&id=344badff&lang=scss"

const __exports__ = script;

export default __exports__